module.exports = __webpack_public_path__ + "static/media/tn.08334106.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tn.svg
// module id = 268
// module chunks = 0